import { EditOutlined } from "@ant-design/icons";
import { NotificationFilled } from "@ant-design/icons/lib/icons";
import { Button, Tag, Tooltip, message } from "antd";
import { memo, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../../api/api";
import DataTable from "../../../Components/DataTable/DataTable";
import { notificationTitle } from "../../../Util/notificationReceivers";
import styles from "./NotificationReceivers.module.css";

const NotificationReceivers = () => {
  const navigate = useNavigate();
  const [notifications, setNotifications] = useState([]);

  const columns = [
    {
      title: "عنوان",
      dataIndex: "title",
      searchable: true,
      render: (value, record) => (
        <div className={styles.title}>
          <span>{value}</span>
          {!record.active && <Tag>غیرفعال</Tag>}
        </div>
      ),
    },
    {
      title: "کلید",
      dataIndex: "key",
      searchable: true,
      render: (value) => <span dir="ltr">{value}</span>,
    },
    {
      title: "متن",
      dataIndex: "message",
      render: (value) => <div className={styles.text}>{value}</div>,
    },
    {
      title: "گیرنده‌ها",
      dataIndex: "mobiles",
      render: (value) => {
        const mobiles = Array.isArray(value) ? value : [];
        if (!mobiles.length) return "—";
        return (
          <div className={styles.tags}>
            {mobiles.map((mobile) => (
              <Tag key={mobile}>
                <span dir="ltr">{mobile}</span>
              </Tag>
            ))}
          </div>
        );
      },
    },
    {
      title: "عملیات",
      render: (_, record) => (
        <Tooltip title="ویرایش">
          <Button
            icon={<EditOutlined />}
            type="primary"
            aria-label="ویرایش"
            onClick={() => navigate("/notifications/edit/" + record.id)}
          />
        </Tooltip>
      ),
    },
  ];

  useEffect(() => {
    loadNotifications();
  }, []);

  const loadNotifications = () => {
    api
      .get("/notification/list")
      .then((res) => {
        const rows = Array.isArray(res.data) ? res.data : [];
        setNotifications(
          rows.map((row) => ({
            ...row,
            title: notificationTitle(row.key),
          }))
        );
      })
      .catch((error) => {
        message.error(
          error.response?.data?.error?.message || "خطا در دریافت اعلان‌ها"
        );
      });
  };

  return (
    <DataTable
      id="NotificationReceivers"
      dataSource={notifications}
      setDataSource={setNotifications}
      columns={columns}
      reload={loadNotifications}
      recordCreatorDisabled
      header={{
        title: "گیرندگان اعلان",
        avatar: { icon: <NotificationFilled />, size: "large" },
      }}
    />
  );
};

export default memo(NotificationReceivers);
